import { createStyles, makeStyles } from '@material-ui/styles';

const style = () =>
  createStyles({
    root: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      padding: '20px',
      gap: '20px'
    },
    academieLabel: {
      margin: 0,
      fontWeight: 500,
      fontSize: '14px',
      lineHeight: '17px',
      fontStyle: 'normal'
    },
    academieSelectContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      '& > select': {
        height: '40px'
      }
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
